const swapElems = document.querySelectorAll(".custom-product-info__swap-item");
const textElems = document.querySelectorAll(".custom-product-info__text-item");

[...swapElems].map((btn, bIdx) => {
  btn.addEventListener("click", () => {
    [...textElems].map((text, tIdx) => {
      if (bIdx !== tIdx) {
        text.classList.add("visually-hidden");
      } else {
        text.classList.remove("visually-hidden");
      }

      [...swapElems].map(btnEl => {
        if (btn !== btnEl) {
          btnEl.classList.remove("is-active");
        } else {
          btnEl.classList.add("is-active");
        }
      });
    });
  });
});
